export default __webpack_public_path__ + "static/media/search.5fcbd5d7.svg";